import script from "./TaskItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskItem.vue?vue&type=script&setup=true&lang=js"

import "./TaskItem.vue?vue&type=style&index=0&id=077fed60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077fed60"]])

export default __exports__